import { render, staticRenderFns } from "./RegionRetailersSection.vue?vue&type=template&id=4d874b0e&scoped=true&"
import script from "./RegionRetailersSection.vue?vue&type=script&lang=js&"
export * from "./RegionRetailersSection.vue?vue&type=script&lang=js&"
import style0 from "./RegionRetailersSection.vue?vue&type=style&index=0&id=4d874b0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d874b0e",
  null
  
)

export default component.exports